import MinorTag from './MinorTag';

export default MinorTag;
